export default __webpack_public_path__ + "static/soc2-e467b299dbc24216ceed4c6b0abd6061.svg";